import { render, staticRenderFns } from "./ReleaseNote.vue?vue&type=template&id=a336ba5c&scoped=true"
import script from "./ReleaseNote.vue?vue&type=script&lang=js"
export * from "./ReleaseNote.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNote.vue?vue&type=style&index=0&id=a336ba5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a336ba5c",
  null
  
)

export default component.exports